export {default} from './Minds'